function Ctrl($scope, imgix) {
  $scope.maxTitleLength = 30;

  $scope.maxDescriptionLength = 200;

  $scope.getBackgroundImage = function() {
    if (!$scope.list) return null;

    const img = ($scope.list.thumbnailImageUrl) ? $scope.list.thumbnailImageUrl : $scope.list.imageUrl;

    return $scope.imgix(img);
  };

  $scope.imgix = function(src) {
    const options = {
      height: 370,
      width: 700
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };
}

Ctrl.$inject = [
  '$scope',
  'jsSdk.imgix'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/curatedListCard/controller.js